import {
  GET_RANKING_LOOKUP_OK,
  GET_RANKING_LOOKUP_ERR,
} from "./ranking.action";

const InitState = {
  error: null,
  content: null,
};

export default function RankingLookupReducer(state = InitState, action) {
  switch (action.type) {
    case GET_RANKING_LOOKUP_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_RANKING_LOOKUP_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }

    default:
      return state;
  }
}
